module.exports = __webpack_public_path__ + "d308b9adcab014a3c7ae1dbdc3c303b8.png";